import { render, staticRenderFns } from "./contractRenew.vue?vue&type=template&id=b9c4af30&scoped=true"
import script from "./contractRenew.vue?vue&type=script&lang=js"
export * from "./contractRenew.vue?vue&type=script&lang=js"
import style0 from "./contractRenew.vue?vue&type=style&index=0&id=b9c4af30&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c4af30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9c4af30')) {
      api.createRecord('b9c4af30', component.options)
    } else {
      api.reload('b9c4af30', component.options)
    }
    module.hot.accept("./contractRenew.vue?vue&type=template&id=b9c4af30&scoped=true", function () {
      api.rerender('b9c4af30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/contract/components/contractRenew.vue"
export default component.exports